import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addTagTitle: {
    defaultMessage: 'Add Tag',
    id: 'wH5cHP',
    description: 'addTagModal.title',
  },
  addNewTagButton: {
    defaultMessage: 'Add New Tag',
    id: 'bDT1+l',
    description: 'addTagModal.addNewTag',
  },
  submitNewTagsButton: {
    defaultMessage: 'Add {tagsCount, plural, one {Tag} other {Tags}}',
    id: 'gZBDU7',
    description: 'addTagModal.addTags',
  },
  addTagErrorTitle: {
    description: 'tagEpics.addTagErrorTitle',
    defaultMessage: 'Add Tag Error',
    id: 'DbDBaH',
  },
  addTagErrorMessage: {
    description: 'tagEpics.addTagErrorMessage',
    defaultMessage: 'Tags could not be saved at this time. Please try again.',
    id: '6WUk71',
  },
});
